import { CUISignupV2 } from '../../components/Signup'

import { signInUpServiceConfig } from '../shared/config'
import injectWidget from '../shared/injectWidget'

export default injectWidget({
  widget: CUISignupV2,
  serviceConfig: signInUpServiceConfig,
})
